import { css } from '@emotion/react'
import styled from '@emotion/styled'

const wrapperStyles = ({ theme }) => css`
  label: bank-slip-installments;

  width: 100%;
  height: 100vh;
  min-width: 320px;
  min-height: 512px;

  ${theme.media.giga} {
    min-width: 1024px;
    min-height: 520px;
  }
`

export const Wrapper = styled('div')(wrapperStyles)
